

































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TransferInternal from "@/services/TransferInternal";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { userModule } from "@/store/modules/user";

@Component
export default class RiwayatTransfer extends Vue {
  @Prop({ required: true }) register!: number;
  @Prop({ type: Boolean, default: false }) isReadOnly!: boolean;
  @Prop({ type: Boolean, default: false }) isForm!: boolean;

  items: any[] = [];
  loading = false;
  panel: number[] = [];
  dialogDetailTransfer = false;
  selectedItem = null;

  get showPenjemput(): boolean {
    const item = this.selectedItem;

    return !!item && (!!item.pickup_user_id || !!item.pickup_at);
  }

  get currentHeaders() {
    if (this.isReadOnly) {
      return this.headers.filter(h => h.value !== "action");
    }

    return this.isForm ? this.headerSm : this.headers;
  }

  get dokters() {
    return storeDokter.list;
  }

  get userLoginId() {
    return userModule.user.id;
  }

  canEdit(item: any) {
    const currentUserId = Number(this.userLoginId);
    const pengirimId = Number(item.from_user?.id);
    const penerimaId = Number(item.to_user?.id);

    const isPengirim = pengirimId === currentUserId;
    const isPenerima = penerimaId === currentUserId;
    const isReceived = !!item.received_at;

    if (isPengirim && !isReceived) return true;

    if (isPenerima) return true;

    return false;
  }

  showDetail(item: any) {
    const raw = item && item.raw ? item.raw : item;
    const tc = raw.transfer_content || {};
    this.selectedItem = {
      ...raw,
      from_unit: raw.from_unit || { name: "-" },
      to_unit: raw.to_unit || { name: "-" },
      from_user: raw.from_user || { nama: "-" },
      to_user: raw.to_user || { nama: "-" },
      dpjp_user: raw.dpjp_user || { nama: "-" },
      received_content: raw.received_content || {},
      transfer_content: {
        ...tc,
        transport_method: tc.transport_method || { name: "-" },
        procedure: tc.procedure || [],
        alat: tc.alat || [],
        penunjang: tc.penunjang || [],
        lampiran: tc.lampiran || [],
        klinis: tc.klinis || null
      }
    };
    this.dialogDetailTransfer = true;
  }

  closeDialog() {
    this.dialogDetailTransfer = false;
  }

  onEdit(item: any) {
    this.$emit("edit", item);
  }

  handleRowClick(item: any, row: any) {
    const rawData = item.raw ? item.raw : item;
    this.$emit("view-detail", rawData, rawData.id);
    this.showDetail;
  }

  get headers() {
    return [
      {
        text: "Tanggal Transfer",
        align: "start",
        sortable: true,
        value: "transferDate"
      },
      {
        text: "Unit Pengirim",
        align: "start",
        sortable: false,
        value: "route1"
      },
      {
        text: "Unit Penerima",
        align: "start",
        sortable: false,
        value: "route2"
      },
      {
        text: "Dokter DPJP",
        align: "start",
        sortable: false,
        value: "dpjp"
      },
      {
        text: "Diagnosa Medis",
        align: "start",
        sortable: false,
        value: "diagnosa"
      },
      {
        text: "Cara Transportasi",
        align: "start",
        sortable: false,
        value: "transportMethod"
      },
      {
        text: "Aksi",
        align: "center",
        sortable: false,
        value: "action",
        width: "80px"
      }
    ];
  }

  get headerSm() {
    return [
      {
        text: "Tanggal Transfer",
        align: "start",
        sortable: true,
        value: "transferDate"
      },
      {
        text: "Unit Pengirim",
        align: "start",
        sortable: false,
        value: "route1"
      },
      {
        text: "Unit Penerima",
        align: "start",
        sortable: false,
        value: "route2"
      },
      {
        text: "Aksi",
        align: "center",
        sortable: false,
        value: "action",
        width: "80px"
      }
    ];
  }

  listKualifikasi = [
    { text: "dr. Spesialis", value: "0" },
    { text: "Dokter", value: "1" },
    { text: "Perawat/ Bidan PRA PK/ PRA BK", value: "2" },
    { text: "Perawat/ Bidan PK 1/ BK 1", value: "3" },
    { text: "Perawat/ Bidan PK 2/ BK 2", value: "4" },
    { text: "Perawat/ Bidan PK 3/ BK 3", value: "5" },
    { text: "Perawat/ Bidan PK 4/ BK 4", value: "6" }
  ];

  getKualifikasiText(value: string | null): string {
    if (!value) return "-";
    const item = this.listKualifikasi.find(k => k.value === value);
    return item ? item.text : "-";
  }

  getYaTidakText(value: boolean | null | undefined): string {
    if (value === true) return "Ya";
    if (value === false) return "Tidak";
    return "-";
  }

  getApgarScoreText(klinis: any): string {
    if (!klinis || !klinis.apgarscore) return "-";

    const menit1 = klinis.apgarscore["1"];
    const menit5 = klinis.apgarscore["5"];

    const parts: string[] = [];
    if (menit1 !== null && menit1 !== undefined) {
      parts.push(`Menit 1: ${menit1}`);
    }
    if (menit5 !== null && menit5 !== undefined) {
      parts.push(`Menit 5: ${menit5}`);
    }

    return parts.length > 0 ? parts.join(", ") : "-";
  }

  mounted() {
    this.load();
  }

  async load() {
    this.items = [];
    this.loading = true;
    try {
      const res = await TransferInternal.getByRegister(this.register);
      this.items = res.data;

      this.$emit("update-count", this.items.length);
    } catch (err) {
      this.$emit("update-count", 0);
      console.error("Error loading transfer history", err);
      appModule.sendErrorNotice("Gagal memuat riwayat transfer");
    } finally {
      this.loading = false;
    }
  }

  @Watch("register")
  onRegisterChange() {
    this.load();
    this.items = [];
  }

  get formattedItems() {
    const sortedItems = [...this.items];
    sortedItems.sort((a, b) => {
      const timeA = a.transfered_at ? new Date(a.transfered_at).getTime() : 0;
      const timeB = b.transfered_at ? new Date(b.transfered_at).getTime() : 0;
      return timeB - timeA;
    });

    return sortedItems.map(item => {
      return {
        raw: item,
        id: item.id,
        diag_text: item.diag_text || "-",
        fromUser: item.from_user?.nama || "-",
        toUser: item.to_user?.nama || "-",
        fromUnit: item.from_unit?.name || "-",
        toUnit: item.to_unit?.name || "-",
        dpjp: item.dpjp_user?.nama || "-",
        transportMethod: item.transfer_content?.transport_method?.name || "-",
        transferDate: this.formatDate(item.transfered_at),
        receivedDate: this.formatDate(item.received_at),
        received_at: item.received_at,
        status: item.received_at ? "Diterima" : "Dalam Proses",
        statusColor: item.received_at ? "green" : "orange"
      };
    });
  }

  formatDate(date: string) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : "-";
  }

  getHumanDate(date: string) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }
}
